import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocaleService } from "../i18n/locale.service";

@Injectable({
  providedIn: "root",
})
export class HeaderService {
  constructor(private localeService: LocaleService) {}

  getHeadersWithoutAuth(): HttpHeaders {
    const contentLanguage = this.localeService.getApiLanguage();

    return new HttpHeaders({
      "X-Application-Code": "ARPM",
      "Content-Language": contentLanguage,
      "X-Correlation-Id": crypto.randomUUID(),
    });
  }
}
